module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "list-block"
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("登录ID")]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim.trim",
      value: (_vm.account),
      expression: "account",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "placeholder": "登录手机号或邮箱"
    },
    domProps: {
      "value": (_vm.account)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.account = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("验证码")]), _vm._v(" "), _c('div', {
    staticClass: "item-input",
    staticStyle: {
      "display": "inline"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.veriCode),
      expression: "veriCode",
      modifiers: {
        "trim": true
      }
    }],
    staticStyle: {
      "width": "6rem",
      "display": "inline"
    },
    attrs: {
      "type": "text",
      "placeholder": "验证码"
    },
    domProps: {
      "value": (_vm.veriCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.veriCode = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline",
      "width": "2.5rem"
    }
  }, [_c('a', {
    attrs: {
      "id": "btn"
    },
    on: {
      "click": _vm.sendVeriCode
    }
  }, [_vm._v("发送")])])])])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("登录密码")]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.password),
      expression: "password",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "password",
      "placeholder": "登录密码"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("新登录ID")]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.newLoginId),
      expression: "newLoginId",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "placeholder": "新ID"
    },
    domProps: {
      "value": (_vm.newLoginId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newLoginId = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("确认新ID")]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.newLoginIdRe),
      expression: "newLoginIdRe",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "placeholder": "确认新ID"
    },
    domProps: {
      "value": (_vm.newLoginIdRe)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newLoginIdRe = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "content-block"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-50"
  }, [_c('router-link', {
    staticClass: "button button-big button-fill button-danger",
    attrs: {
      "to": {
        name: 'me'
      }
    }
  }, [_vm._v("取消")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-50"
  }, [_c('a', {
    staticClass: "button button-big button-fill button-success",
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("确认")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "bar bar-nav"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("修改手机/邮箱")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-972b3f56","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/User/MyLogin/ChangeLoginID.vue
// module id = 1698
// module chunks = 8